import React from "react";
import { IonImg } from "@ionic/react";

function ImageUpload({ data }) {
  return <IonImg src={data.url} />;
}

export default ImageUpload;
